"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _excluded = ["height", "width", "children", "color"]; ////////////////////////////////
// Component for use in creating new icons only, not intended for use outside of the 'icon' director
////////////////////////////////
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    vertical: {
      height: '100%'
    },
    horizontal: {
      width: 'inherit'
    },
    warning: {
      fill: theme.palette.warning.main
    },
    success: {
      fill: theme.palette.success.main
    }
  };
});
var calculateIconDirection = function calculateIconDirection(width, height) {
  if (width > height) return 'vertical';
  if (width < height) return 'horizontal';
  return '';
};
var Icon = function Icon(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    children = _ref.children,
    color = _ref.color,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var iconDirection = calculateIconDirection(width, height);
  return __jsx(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 ".concat(width, " ").concat(height),
    classes: {
      root: (0, _clsx.default)(classes[iconDirection], color === ('success' || 'warning') && classes[color])
    },
    color: color
  }, rest), children);
};
var _default = Icon;
exports.default = _default;